export enum PartType {
    text, // 普通文本
    emoji, // emoji
    mention, // @
    link, // 链接
}

class Part {
    type: PartType;
    text: string;
    data: any;

    constructor( type: PartType, text: string, data?: any ) {
        this.text = text;
        this.type = type;
        this.data = data;
    }
}

export class Parts {
    public content = "";

    constructor( content: string ) {
        this.content = content;
    }

    private _parts: Part[] | null = null;
    public get parts() {
        if ( !this._parts ) {
            // 解析@ 处理text
            this._parts = this.parseMention();
            // 解析链接
            this._parts = this.parseLinks( this._parts );
        }
        return this._parts;
    }

    // 解析普通文本，如果有@ 加入@
    private parseMention(): Array<Part> {
        let text = this.content;
        const parts = new Array<Part>();
        let i = 0;
        while ( text.length > 0 ) {
            const mentionMatchResult = text.match( /@(\S+)/m );
            let index = mentionMatchResult?.index;
            if ( index === undefined ) {
                index = -1;
            }
            if ( !mentionMatchResult || index === -1 ) {
                parts.push( new Part( PartType.text, text ) );
                break;
            }
            if ( index > 0 ) {
                parts.push( new Part( PartType.text, text.substring( 0, index ) ) );
            }

            parts.push( new Part( PartType.mention, text.substr( index, mentionMatchResult[0].length ) ) );
            text = text.substring( index + mentionMatchResult[0].length );
            i++;
        }
        return parts;
    }

    parseLinks( parts: Array<Part> ): Array<Part> {
        if ( !parts || parts.length <= 0 ) {
            return parts;
        }
        const newParts = new Array<Part>();
        const len = parts.length;
        for ( let index = 0; index < len; index++ ) {
            const part = parts[index];
            if ( part.type === PartType.text ) {
                let text = part.text;
                while ( text.length > 0 ) {
                    const matchResult = text.match(
                        // eslint-disable-next-line no-useless-escape
                        /((http|ftp|https):\/\/|www.)[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/,
                    );
                    if ( !matchResult ) {
                        newParts.push( new Part( PartType.text, text ) );
                        break;
                    }
                    let index = matchResult?.index;
                    if ( index === undefined ) {
                        index = -1;
                    }
                    if ( index === -1 ) {
                        newParts.push( new Part( PartType.text, text ) );
                        break;
                    }
                    if ( index > 0 ) {
                        newParts.push( new Part( PartType.text, text.substring( 0, index ) ) );
                    }
                    newParts.push( new Part( PartType.link, text.substr( index, matchResult[0].length ) ) );
                    text = text.substring( index + matchResult[0].length );
                }
            } else {
                newParts.push( part );
            }
        }
        return newParts;
    }
}
